// removed by extract-text-webpack-plugin
module.exports = {"section":"c-Section__section","half":"c-Section__half","clear":"c-Section__clear"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Section/Section.scss
// module id = 505
// module chunks = 0